var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 220",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ammei8gqca"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 220",
    style: {
      fill: "#032f3c"
    },
    d: "M0 0h19v24H0z"
  }))), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1",
    cx: 32,
    cy: 32,
    r: 32,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 218",
    style: {
      clipPath: "url(#ammei8gqca)"
    },
    transform: "translate(23 20)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 15047",
    d: "M10.614 8.255V1.769L17.1 8.255M2.359 0A2.35 2.35 0 0 0 0 2.359v18.869a2.358 2.358 0 0 0 2.359 2.359H16.51a2.358 2.358 0 0 0 2.359-2.359V7.076L11.793 0z",
    transform: "translate(-.683 .181)",
    style: {
      fill: "#032f3c"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcn);
export default __webpack_public_path__ + "static/media/upload-icn.d60a737c520485b3fd59dc544a35390b.svg";
export { ForwardRef as ReactComponent };